import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0005',
    ecrans: ['00-2'],
    params: ['id', '?tsacleint']
});

